import React from "react";
import { T } from "Components";

import DashboardCard from "./DashboardCard";
import useStatistics from "../../Infrastructure/useStatistics";
import { FormatCurrency, FormatNumber, Initials } from "../../Infrastructure/format";

/** En Yüksek Borçlu Üyeler — satıra tıklayınca üye detayına gider. */
const TopDebtors = ({ onNavigate }) => {
  const { data, loading, error } = useStatistics("/Statistics/TopDebtors", []);

  const debtors = Array.isArray(data) ? data : [];

  return (
    <DashboardCard
      title={T.Main("Dashboard.Statistics.TopDebtors")}
      description={T.Main("Dashboard.Statistics.ByOverdueBalance")}
      // Gezinme yoksa (ör. admin Birlik Özeti) bağlantı gösterilmez
      action={onNavigate ? T.Main("Dashboard.Statistics.SeeAll") : undefined}
      onAction={() => onNavigate && onNavigate("/Member/List")}
      loading={loading}
      error={error}
      empty={debtors.length === 0}
      bodyClassName="fdash__debtors"
    >
      {debtors.map((debtor) => (
        <div
          className="fdash__debtors__row"
          key={debtor.MemberId}
          role="button"
          tabIndex={0}
          onClick={() => onNavigate && onNavigate(`/Member/Detail/${debtor.MemberId}`)}
          onKeyPress={(e) => {
            if (e.key === "Enter" && onNavigate) onNavigate(`/Member/Detail/${debtor.MemberId}`);
          }}
        >
          <span className="fdash__debtors__avatar">{Initials(debtor.FullName)}</span>
          <span className="fdash__debtors__name">
            <b>{debtor.FullName}</b>
            <span>{debtor.Branch}</span>
          </span>
          <span className="fdash__debtors__amount">
            <b>{FormatCurrency(debtor.Amount, 0)}</b>
            <span>
              {`${FormatNumber(debtor.OverdueDays)} ${T.Main("Dashboard.Statistics.DaysOverdue")}`}
            </span>
          </span>
        </div>
      ))}
    </DashboardCard>
  );
};

export default TopDebtors;
